import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CaptureImageFromCameraComponent } from '../capture-image-from-camera/capture-image-from-camera.component';
import { Observable, pipe, Subject, of } from "rxjs";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';

interface UploadFileItem {
  id: string;
  file: File;
  name: string;
  size: number;
  status: 'pending' | 'uploading' | 'success' | 'failed';
  progress: number;
  errorMessage?: string;
  sizeError?: string;
}

@Component({
  selector: 'app-formly-dynamic-modal',
  templateUrl: './formly-dynamic-modal.component.html',
  styleUrls: ['./formly-dynamic-modal.component.css'],
  standalone: false
})
export class FormlyDynamicModalComponent implements OnInit {
  tabType = '';
  searchinput: FormGroup;
  searchInput='';
  license_data: any;
  sortcolumn = '';
  sortorder = '';
  selectedUsers: any[] = [];
  clickedPhoto: File;

  page = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  displayedColumns: string[] = [
    'Status'
    , 'Business Legal Name'
    , 'License Type'
    , 'Action'
  ];

  form = new FormGroup({});
  model: {
    dynamicData?: any[];
  }  = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];
  modalWidth: any;
  coutryCode: any;
  mailingCountry: any;
  countryKey: FormlyFieldConfig<import("@ngx-formly/core").FormlyFieldProps & { [additionalProperties: string]: any; }>;
  mailingCountryKey: FormlyFieldConfig<import("@ngx-formly/core").FormlyFieldProps & { [additionalProperties: string]: any; }>;
  country_id=''
  call_stateapi=false

  mailing_country_id=''
  mailing_call_stateapi=false

  docForm: FormGroup;
  selectedFile;
  AttachmentsName = '';
  apiImage: any;
  docTitle: any;
  formSubmitted = false;
  selectedFiles: File[] = [];
  apiImages: File[] = [];
  isApplicable: false;
  AttachFiles = [];
  attachNames = [];
  max_file_count=0;
  supportedFile={
   maxSize:'',
   fileSize:0,
   type:''
 };
 supportedDocType = '';
 supporetsFiles = '';
 supportMaxFileSize = '';
 @ViewChild('attachInput') attachInputRef: any;
  countryOfOriginCountry: any;
  selectedResidentialCountryID: any;
  selectedMailingCountryID: any;
  capturedPhotoFromModal: any;
  timestamp: any;
  isCountryOriginData: boolean = false;
  ResidentialCountryID: any;
  residentialZip: any;
  indMailingZip: any;

  maxFileSizeBytes = 0;
  uploadedDocCounts: any;
  remainingUploadCounts: any;
  WEBAPP_ATTACHMENT_LIMIT: any;

  constructor(
    @Optional() public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
    , private spinner: NgxSpinnerService
    , private _api: ApiService
    , private cookieService: CookieService
    , private _utils: UtilitiesService
    , private dialog: MatDialog
  ) {
    this.searchinput = this.formBuilder.group({
      search_field: new FormControl(''),
  });
  this.docForm = this.formBuilder.group({
    appDoc: ['upload_from_device'],
    comments: new FormControl(''),
    uploadDocuments: [null],
});

  }

  getDocTypeCount(docType, counts) {
    if (Object.prototype.hasOwnProperty.call(counts, docType)) {
      return { key: docType, count: counts[docType] };
    }
    return { key: docType, count: 0 };
  }

  ngOnInit(): void {
    this.tabType = this.data['tabType']

    if(this.tabType === 'key_person_tab') {
      this.fields = this.data['indJsonForm'];
      if(localStorage.getItem('authToken')){
        this.getCountryList().subscribe(cres=>{
      });
    }

      this.bindFunctionsToTemplateOptions(this.fields);
      this.modalWidth = this.data['modalWidth'];
    }

    if(this.tabType === 'document_tab') {
      console.log('-------------this.data[do', this.data)
      this.getSupportedFiles();
      this.modalWidth = this.data['modalWidth'];
      this.docTitle = this.data['docType'];
      this.isApplicable = this.data['isApplicable'];
      this.WEBAPP_ATTACHMENT_LIMIT = this.data?.WEBAPP_ATTACHMENT_LIMIT;
      this.uploadedDocCounts = this.getDocTypeCount(this.docTitle, this.data?.uploadedDocCounts);
      this.uploadedDocCounts =this.uploadedDocCounts?.count;
      this.remainingUploadCounts = this.data?.WEBAPP_ATTACHMENT_LIMIT - this.uploadedDocCounts;
      console.log(this.uploadedDocCounts);
      console.log(this.remainingUploadCounts);

      // console.log('----------this.isApplicable', this.isApplicable);
      if(this.isApplicable){
        // Conditionally required 'uploadDocuments' based on 'appDoc' value
        this.docForm.get('appDoc')?.valueChanges.subscribe((value) => {
          if (value === 'upload_from_device' || value === 'upload_from_mobile') {
              this.docForm.get('uploadDocuments')?.setValidators(Validators.required);
          }else {
              this.docForm.reset();
              this.docForm.get('uploadDocuments')?.clearValidators();
          }
              this.docForm.get('uploadDocuments')?.updateValueAndValidity();
        });
      }else{
        this.docForm.reset();
        this.docForm.get('uploadDocuments')?.clearValidators();
        this.docForm.get('appDoc')?.clearValidators();
        this.docForm.get('uploadDocuments')?.updateValueAndValidity();
        this.docForm.get('appDoc')?.updateValueAndValidity();
      }

    }

    if(this.tabType === 'lic_tab') {
      this.modalWidth = this.data['modalWidth'];
    }
}

onInMailingCountryChange(event: any) {
  this.indMailingZip = '';
  this.selectedMailingCountryID = event;
    const fieldsToClear = ['mailingState', 'mailingCity', 'mailingZip'];
    fieldsToClear.forEach(key => {
      const field = this.findFieldByKey(this.fields, key);
      if (field && field.formControl) {
        field.formControl.setValue(null, { emitEvent: false });
        field.formControl.markAsUntouched();
        field.formControl.markAsPristine();
      }
    });
}
functionMap = {
  onResidentialCountryChange: this.onResidentialCountryChange.bind(this),
  onInMailingCountryChange: this.onInMailingCountryChange.bind(this),
  getSelectedCountryOfOrigin: this.getSelectedCountryOfOrigin.bind(this),
  ValidateResidentialZipCode: (field: FormlyFieldConfig, event: FocusEvent) => this.ValidateResidentialZipCode(field, event),
  ValidateMailingZipCode: (field: FormlyFieldConfig, event: FocusEvent) => this.ValidateMailingZipCode(field, event),
};

bindFunctionsToTemplateOptions(fields: FormlyFieldConfig[]) {
  fields.forEach(field => {
    if (field.fieldGroup) {
      this.bindFunctionsToTemplateOptions(field.fieldGroup);
    } else if (field.templateOptions && field.templateOptions.onClick) {
      const functionName = field.templateOptions.onClick;
      if (this.functionMap[functionName]) {
        field.templateOptions.onClick = this.functionMap[functionName];
      }
    }else if (field.templateOptions && field.templateOptions.onOptionSelected) {
        const functionName = field.templateOptions.onOptionSelected;
        if (this.functionMap[functionName]) {
          field.templateOptions.onOptionSelected = this.functionMap[functionName];
        }
    }
    // Bind blur event correctly
    if (field.templateOptions?.blurEvent) {
      const functionName = field.templateOptions.blurEvent;
      if (this.functionMap[functionName]) {
        field.templateOptions.blur = (field: FormlyFieldConfig, event: FocusEvent) => {
          if(functionName==='ValidateResidentialZipCode'){
            this.functionMap[functionName](field?.formControl?.value, true);

          }else if(functionName==='ValidateMailingZipCode'){
            this.functionMap[functionName](field?.formControl?.value, true);

          }
        }
      }
    }


     // Recursively bind functions for nested field groups
     if (field.fieldGroup) {
      this.bindFunctionsToTemplateOptions(field.fieldGroup);
    }
    if (field.templateOptions?.changeFunction) {
      const functionName = field.templateOptions.changeFunction;
      if (this.functionMap[functionName]) {
        field.templateOptions.selectionChange = (field: FormlyFieldConfig,event:Event) => {
        if(functionName==='onResidentialCountryChange'){
        if(field?.formControl?.value){
        this.functionMap[functionName](field?.formControl?.value);
        }
      }  else  if(functionName==='onInMailingCountryChange'){
        if(field?.formControl?.value){
        this.functionMap[functionName](field?.formControl?.value);
        }
      }
    }
  }
}
  });
}

findFieldByKey(fields: FormlyFieldConfig[], key: string): FormlyFieldConfig | null {
  for (const field of fields) {
    if (field.key === key) {
      return field;
    }
    if (field.fieldGroup && field.fieldGroup.length) {
      const nestedField = this.findFieldByKey(field.fieldGroup, key);
      if (nestedField) {
        return nestedField;
      }
    }
  }
  return null;
}

getValueByKey(key: string, type?) {
  return this.form.get(key)?.value;
}

getCountryOfOrigin(search?, type?) {
  let countryOfOriginAutoCompleteField: any
    countryOfOriginAutoCompleteField = this.findFieldByKey(this.fields, 'countryOfOrigin');

  if(search !=  undefined && search && search.length > 0){
      this.spinner.show();
      const apiData = {
       instance_id: localStorage.getItem('instance_id'),
        email: localStorage.getItem('email'),
        search: search
      };
      this._api.functionPOST('web/allCountriesList', apiData).subscribe((response) => {
        // console.log('----------------data', response['data']);
        this.updateFieldOptions('countryOfOrigin', response['data'].map((country: { bt_country_id: any; name: any; }) => ({
          value: country.bt_country_id,
          label: country.name
        })));
        this.spinner.hide();
      },
        err => {
        });
  }else {
    // console.log('-------------');
    if (countryOfOriginAutoCompleteField) {
      countryOfOriginAutoCompleteField.formControl?.setValue('', { emitEvent: false });
      this.isCountryOriginData = false;
    }
  }
  }

 getSelectedCountryOfOrigin(data: any) {
    // console.log('---------data', data);
    let countryOfOriginAutoCompleteField: any;
      countryOfOriginAutoCompleteField = this.findFieldByKey(this.fields, 'countryOfOrigin');
      this.model['countryOfOrigin'] = data.label;
    if (countryOfOriginAutoCompleteField && countryOfOriginAutoCompleteField.formControl?.value !== data.label) {
      countryOfOriginAutoCompleteField.formControl?.setValue(data.label, { emitEvent: false });
      this.isCountryOriginData = true;

    }
  }

// get country list
getCountryList(): Observable < boolean > {
  return new Observable(observer => {
  this.spinner.show();
  const apiData = {
   instance_id: localStorage.getItem('instance_id'),
    email: localStorage.getItem('email')
  };
  this._api.functionPOST('web/countriesList', apiData).subscribe((res) => {
    this.updateFieldOptions('residentialCountry', res['data'].map((country: { bt_country_id: any; name: any; }) => ({
      value: country.bt_country_id,
      label: country.name
    })));
    this.updateFieldOptions('indMailingCountry', res['data'].map((country: { bt_country_id: any; name: any; }) => ({
      value: country.bt_country_id,
      label: country.name
    })));
    observer.next(true);
    observer.complete();
    this.spinner.hide();
  },
    err => {
    });
  });
}

  onResidentialCountryChange(event: any) {
    this.residentialZip = '';
        this.selectedResidentialCountryID = event;
        const fieldsToClear = ['residentialState', 'residentialCity', 'residentialZip'];
        fieldsToClear.forEach(key => {
          const field = this.findFieldByKey(this.fields, key);
          if (field && field.formControl) {
            field.formControl.setValue(null, { emitEvent: false });
            field.formControl.markAsUntouched();
            field.formControl.markAsPristine();
          }
        });
  }

  updateFieldOptions(key: string, options: any[]) {
      const field = this.findFieldByKey(this.fields, key);
      if (field && field.templateOptions) {
        field.templateOptions.options = options;
      }

  }

  ValidateResidentialZipCode(zip_code?, type?) {

    const zipCode = zip_code;
    const stateField = this.findFieldByKey(this.fields, 'residentialState');
    const cityField = this.findFieldByKey(this.fields, 'residentialCity');
    const zipCodeField = this.findFieldByKey(this.fields, 'residentialZip');
    console.log('--------------------zip', zipCode);
    if(zipCode && this.residentialZip !== zipCode){
      this.spinner.show();
      const apiData = {
        zipcode: zipCode,
        Country: this.selectedResidentialCountryID
      };
      this._api.functionPOST('zipcode/findZip', apiData).subscribe((response) => {

        if(response['success'] && response['data'].length > 0){
               //this.model['residentialZip'] = response['data'][0]['bt_zipcodes_id'];
              if (stateField) {
                stateField.formControl?.setValue(response['data'][0]['bt_region']['name'], { emitEvent: false });

                  this.model['residentialState'] = response['data'][0]['bt_region']['name'];

              }
              if (cityField) {
                cityField.formControl?.setValue(response['data'][0]['city'], {emitEvent: false});
                this.model['residentialCity'] = response['data'][0]['city'];
                  this.model['residentialCity'] = response['data'][0]['city'];
              }
        } else {
          this.residentialZip = '';
          this._api.openSnackBar('Invalid zipcode', 'Error');
            if (stateField) {
              stateField.formControl?.setValue('', { emitEvent: false });
            }
            if (cityField) {
              cityField.formControl?.setValue('', {emitEvent: false});
            }
            if (zipCodeField) {
              zipCodeField.formControl?.setValue('', {emitEvent: false});
            }
        }
        this.spinner.hide();
      },
        err => {
        });
      }
      if(!zipCode){
        if (stateField) {
          stateField.formControl?.setValue('', { emitEvent: false });
        }
        if (cityField) {
          cityField.formControl?.setValue('', {emitEvent: false});
        }
        if (zipCodeField) {
          zipCodeField.formControl?.setValue('', {emitEvent: false});
        }
      }
      this.residentialZip = zipCode;
  }

  ValidateMailingZipCode(zip_code?, type?) {
    let mailingStateField: any;
    let mailingCityField: any;
    let mailingZipCodeField: any;
    const zipCode = zip_code;
       mailingStateField = this.findFieldByKey(this.fields, 'mailingState');
       mailingCityField = this.findFieldByKey(this.fields, 'mailingCity');
       mailingZipCodeField = this.findFieldByKey(this.fields, 'mailingZip');

    if(zipCode && this.indMailingZip!=zipCode){


      this.spinner.show();
      const apiData = {
        zipcode: zipCode,
        Country: this.selectedMailingCountryID
      };
      this._api.functionPOST('zipcode/findZip', apiData).subscribe((response) => {

          if(response['data'].length > 0){

            if (mailingStateField) {
              mailingStateField.formControl?.setValue(response['data'][0]['bt_region']['name'], { emitEvent: false });

                this.model['mailingState'] = response['data'][0]['bt_region']['name'];
            }
            if (mailingCityField) {
              mailingCityField.formControl?.setValue(response['data'][0]['city'], {emitEvent: false});

                this.model['mailingCity'] = response['data'][0]['city'];

            }

          } else {
            this.indMailingZip = '';
            this._api.openSnackBar('Invalid zipcode', 'Error');
            if (mailingStateField) {
              mailingStateField.formControl?.setValue('', { emitEvent: false });
            }
            if (mailingCityField) {
              mailingCityField.formControl?.setValue('', {emitEvent: false});
            }
            if (mailingZipCodeField) {
              mailingZipCodeField.formControl?.setValue('', {emitEvent: false});
            }
          }
          this.spinner.hide();
        },
        err => {
        });
      }
      if(!zipCode){
        if (mailingStateField) {
          mailingStateField.formControl?.setValue('', { emitEvent: false });
        }
        if (mailingCityField) {
          mailingCityField.formControl?.setValue('', {emitEvent: false});
        }
        if (mailingZipCodeField) {
          mailingZipCodeField.formControl?.setValue('', {emitEvent: false});
        }
      }
      this.indMailingZip = zipCode;

  }

  close() {
    this.form.reset();
    this.dialogRef.close();
  }

  addIndividualDetails() {
    if (this.form.valid) {
      this.dialogRef.close(this.model);
    }else{
      this._api.openSnackBar('Please complete all required fields.', 'Error');
    }
  }

// Serach License
  filterValidation(tag){
    let u_search_f = this.searchinput.get('search_field').value;

    if (!u_search_f) {
      this._api.openSnackBar('Search field is empty.', 'Error');
      return
    }else{
      this.getLicDetails({ page: 1 });
    }
  }

  getLicDetails(data?) {
  const apiData = {
    'search_field': this.searchinput.get('search_field').value,
   instance_id: localStorage.getItem('instance_id'),
    email: localStorage.getItem('email')
    }
    if (this.sortcolumn !== '') {
      apiData['sortcolumn'] = this.sortcolumn;
    }
    if (this.sortorder !== '') {
      apiData['sortorder'] = this.sortorder;
    }

    this.spinner.show();
    this._api.functionPOST('web/licenseSearch', apiData).subscribe((response) => {
      this.license_data = response.data.data
      this.spinner.hide();
    });
  }

  sortData($event) {
    this.sortcolumn = $event.active;
    this.sortorder = $event.direction.toUpperCase();
    this.page.index=0
    this.getLicDetails({ page: 1 });
  }

  PageChange($event) {
    this.page.pageSize = $event.pageSize;
    this.page.index = $event.pageIndex;
    this.getLicDetails({ page: $event.pageIndex + 1 });
  }

   onCheckboxChange(user: any, event: MatCheckboxChange) {
     if (event.checked) {
       this.selectedUsers.push(user);
     } else {
       this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
     }
   }

   submitSelectedRow() {
    this.dialogRef.close(this.selectedUsers);

   }

  getSupportedFiles() {
    const apiData = {
     instance_id: localStorage.getItem('instance_id'),
      email: localStorage.getItem('email')
    };
    this._api.functionPOST('web/getSupportedFileDetails', apiData).subscribe((res) => {
      if (res['data'] ) {
        const files   =  res['data']['supported_file_types'];
        this.supportedDocType = files.split(',');
      }
      this.maxFileSizeBytes = res['data']['max_file_size_bytes'];
      var size = (res['data']['max_file_size_bytes']/1000000)+' MB';
      this.supportedFile={
        maxSize:size,
        fileSize:res['data']['max_file_size_bytes'],
        type:res['data']['supported_file_types']
      };
      this.max_file_count = parseInt(res['data']['max_file_count'])
     this.supporetsFiles = '* Supported document types are ' + res['data']['supported_file_types'].replaceAll(",",", ");
     this.supportMaxFileSize = '* Maximum file size is ' + this.supportedFile['maxSize'];
    },
      err => {
      });
  }

  openPopUpForCaptureImg(){
    const dialogRef = this.dialog.open(CaptureImageFromCameraComponent, {
      width: '100vw',
      height: '100dvh',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      data: {
        pageTitle: 'Capture Photo',
        message: this.docTitle,
        pageType: 'CAPTURE_PHOTO',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.model.latitude = result.latitude;
        // this.model.longitude = result.longitude;
        this.timestamp = result.timestamp;
        this.capturedPhotoFromModal = result.image;
      }
    });
  }

  convertDataURLToBlob(dataURL: string): Blob {
    const parts = dataURL.split(',');
    const mimeType = parts[0].match(/:(.*?);/)[1];
    const byteString = atob(parts[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([uint8Array], { type: mimeType });
  }

  onFileSelectedSingle(event: any) {
    if(this.AttachFiles.length>=this.max_file_count){
      this._api.openSnackBar('Supported maximum file count should be less than or equal to '+this.max_file_count, 'Error');
      return;
    }
    const selectedFile = event.target.files[0];
    if(this.AttachFiles.length>=this.max_file_count){
      this._api.openSnackBar('Supported maximum file count should be less than or equal to '+this.max_file_count, 'Error');
      return;
    }
    this.AttachFiles = [selectedFile];
    this.attachNames = [selectedFile.name];


  //   for (let i = 0; i <= event.target.files.length - 1; i++) {
  //     const file = event.target.files[i];
  //     console.log('-------------file', file)
  // const selectedFile = event.target.files[i];
  // if(this.AttachFiles.length>=this.max_file_count){
  //   this._api.openSnackBar('Supported maximum file count should be less than or equal to '+this.max_file_count, 'Error');
  //   return;
  // }
  // this.AttachFiles.push(selectedFile);
  // this.attachNames.push(selectedFile.name);
  // }
  // this.attachInputRef.nativeElement.value = '';
  }

  onFileSelectedww(event: any) {
    const newFiles: File[] = Array.from(event.target.files);

    if (this.AttachFiles.length >= this.max_file_count) {
      this._api.openSnackBar(
        'Supported maximum file count should be less than or equal to ' + this.max_file_count,
        'Error'
      );
      event.target.value = '';
      return;
    }

    const remainingSlots = this.max_file_count - this.AttachFiles.length;

    if (newFiles.length > remainingSlots) {
      this._api.openSnackBar(
        'Supported maximum file count should be less than or equal to ' + this.max_file_count,
        'Error'
      );
    }

    newFiles.slice(0, remainingSlots).forEach((file: File) => {
      this.AttachFiles.push(file);
      this.attachNames.push(file.name);
    });

    event.target.value = '';
  }

  // component properties — replace AttachFiles / attachNames with this
  fileItems: UploadFileItem[] = [];
  isUploading = false;
  overallProgress = 0;

  get uploadedCount(): number {
    return this.fileItems.filter(f => f.status === 'success' || f.status === 'failed').length;
  }

  onFileSelected(event: any) {
    const newFiles: File[] = Array.from(event.target.files);

    if (newFiles.length === 0) {
      return;
    }

    const totalAlreadyCounted = this.uploadedDocCounts + this.fileItems.length;
    const remainingSlots = this.WEBAPP_ATTACHMENT_LIMIT - totalAlreadyCounted;

    if (remainingSlots <= 0) {
      this._api.openSnackBar(
        `${this.buildAlreadyCountedMessage()} The maximum allowed is ${this.WEBAPP_ATTACHMENT_LIMIT} files.`,
        'Error'
      );
      event.target.value = '';
      return;
    }

    if (newFiles.length > remainingSlots) {
      this._api.openSnackBar(this.buildTooManySelectedMessage(remainingSlots), 'Error');
      event.target.value = '';
      return;
    }

    newFiles.forEach((file: File) => {
      const sizeError = this.maxFileSizeBytes && file.size > this.maxFileSizeBytes
        ? `File size exceeds the ${this.formatFileSize(this.maxFileSizeBytes)} limit`
        : undefined;

      this.fileItems.push({
        id: `${file.name}_${file.size}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
        file,
        name: file.name,
        size: file.size,
        status: 'pending',
        progress: 0,
        sizeError,
      });
    });

    event.target.value = '';
  }

  private buildTooManySelectedMessage(remainingSlots: number): string {
    const hasUploaded = this.uploadedDocCounts > 0;
    const hasSelected = this.fileItems.length > 0;

    if (hasUploaded) {
      return `Too many files selected. You already have ${this.uploadedDocCounts} files uploaded. The maximum allowed is ${this.WEBAPP_ATTACHMENT_LIMIT} files. Please select ${remainingSlots} or fewer files.`;
    } else if (hasSelected) {
      return `Too many files selected. You already selected ${this.fileItems.length} files. The maximum allowed is ${this.WEBAPP_ATTACHMENT_LIMIT} files. Please select ${remainingSlots} or fewer files.`;
    }
    return `Too many files selected. The maximum allowed is ${this.WEBAPP_ATTACHMENT_LIMIT} files.`;
  }

  private buildAlreadyCountedMessage(): string {
    const hasUploaded = this.uploadedDocCounts > 0;
    const hasSelected = this.fileItems.length > 0;

    if (hasUploaded && hasSelected) {
      return `You already have ${this.uploadedDocCounts} files uploaded and ${this.fileItems.length} files selected.`;
    } else if (hasUploaded) {
      return `You already have ${this.uploadedDocCounts} files uploaded.`;
    } else if (hasSelected) {
      return `You already selected ${this.fileItems.length} files.`;
    }
    return '';
  }

  removeFile(id: string) {
    this.fileItems = this.fileItems.filter(f => f.id !== id);
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const value = bytes / Math.pow(1024, i);
    return `${i === 0 ? value : value.toFixed(1)} ${units[i]}`;
  }

  uploadAppDoc() {
    this.formSubmitted = true;
    const radioSelect = this.docForm.get('appDoc').value;

    if (!radioSelect) {
      this._api.openSnackBar('Please select an option.', 'Error');
      return false;
    } else if (radioSelect === 'upload_from_device' && this.fileItems.length === 0) {
      this.capturedPhotoFromModal = '';
      this._api.openSnackBar('Select a file', 'Error');
      return false;
    } else if (radioSelect === 'upload_from_mobile' && !this.capturedPhotoFromModal) {
      this.fileItems = [];
      this._api.openSnackBar('Take Photo', 'Error');
      return false;
    }

    if (radioSelect === 'upload_from_mobile' && this.capturedPhotoFromModal && this.fileItems.length === 0) {
      const blob = this.convertDataURLToBlob(this.capturedPhotoFromModal);
      const fileName = `${this.docTitle}_${this.timestamp}.png`;
      const file = new File([blob], fileName, { type: blob.type });
      this.fileItems.push({
        id: `${fileName}_${Date.now()}`,
        file,
        name: fileName,
        size: file.size,
        status: 'pending',
        progress: 0,
      });
    }

    this.isUploading = true;
    this.uploadNextFile(0);
  }

  private performUpload(item: UploadFileItem): Observable<any> {
    const docComments = this.docForm.get('comments').value;
    const apiData = new FormData();
    apiData.append('files', item.file, item.name);
    apiData.append('instance_id', localStorage.getItem('instance_id'));
    apiData.append('email', localStorage.getItem('email'));
    apiData.append('doc_type', this.docTitle);
    apiData.append('doc_comment', docComments);
    apiData.append('is_pii', 'N');
    apiData.append('isNotApplicable', 'N');

    item.status = 'uploading';
    item.progress = 0;
    item.errorMessage = undefined;

    return this._api.uploadWithProgress('web/uploadDocument', apiData).pipe(
      tap((event: any) => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          item.progress = Math.round((event.loaded / event.total) * 100);
          this.updateOverallProgress();
        } else if (event.type === HttpEventType.Response) {
          const body = event.body;
          console.log("fffffff", body);
          if (body?.success) {
            item.status = 'success';
            item.progress = 100;
          } else {
            item.status = 'failed';
            item.errorMessage = body?.data || 'Upload failed. Please try again.';
          }
          this.updateOverallProgress();
        }
      }),
      catchError((err: HttpErrorResponse) => {
        item.status = 'failed';
        item.progress = 0;
        item.errorMessage = err?.error || err?.error || 'Upload failed. Please try again.';
        this.updateOverallProgress();
        return of(null);
      })
    );
  }

  private uploadNextFile(index: number) {
    if (index >= this.fileItems.length) {
      this.isUploading = false;
      this.checkAllDone();
      return;
    }
    const item = this.fileItems[index];
    if (item.status === 'success') {
      this.uploadNextFile(index + 1);
      return;
    }
    if (item.sizeError) {
      item.status = 'failed';
      item.errorMessage = item.sizeError;
      this.uploadNextFile(index + 1);
      return;
    }

    this.performUpload(item).subscribe({
      next: () => {}, // per-event handling already happens inside performUpload's tap()
      complete: () => this.uploadNextFile(index + 1),
    });
  }

  retryFile(id: string) {
    const item = this.fileItems.find(f => f.id === id);
    if (!item) return;
    this.performUpload(item).subscribe({
      next: () => {},
      complete: () => this.checkAllDone(),
    });
  }
  private checkAllDone() {
    const allSuccess = this.fileItems.length > 0 && this.fileItems.every(f => f.status === 'success');
    if (allSuccess) {
      this._api.openSnackBar('All documents uploaded successfully.', 'Success');
      setTimeout(() => this.dialogRef.close(true), 700);
    }
  }

  private updateOverallProgress() {
    if (this.fileItems.length === 0) {
      this.overallProgress = 0;
      return;
    }
    const total = this.fileItems.reduce((sum, f) => sum + (f.status === 'success' ? 100 : f.progress), 0);
    this.overallProgress = Math.round(total / this.fileItems.length);
  }

  uploadNotAppDoc() {
    const comments = this.docForm.get('comments').value;
    if(!comments){
      this._api.openSnackBar('Enter Comments', 'Error');
      return false;

    }
    const docComments = this.docForm.get('comments').value;
      const apiData = new FormData();
      apiData.append('instance_id', localStorage.getItem('instance_id'));
      apiData.append('email', localStorage.getItem('email'));
      apiData.append('doc_type', this.docTitle);
      apiData.append('doc_comment', docComments);
      apiData.append('isNotApplicable', 'Y');
      this._api.functionPOST('web/uploadDocument' , apiData).subscribe((response) => {
        if(response['success']){
          this._api.openSnackBar(response['data'] , 'Success');
          this.selectedFile = '';
          this.apiImage = '';
          this.docForm.reset();
          this.dialogRef.close(true);
        }
      },
      err => {
        this._api.openSnackBar(err.error, 'Error');
      });
      this.spinner.hide();
    }

  uploadAppDoc1111() {
    this.formSubmitted = true;
    const radioSelect = this.docForm.get('appDoc').value;

    if (!radioSelect) {
      this._api.openSnackBar('Please select an option.', 'Error');
      return false;
    } else if (radioSelect === 'upload_from_device' && this.AttachFiles.length === 0) {
      this.capturedPhotoFromModal = '';
      this._api.openSnackBar('Select a file', 'Error');
      return false;
    } else if (radioSelect === 'upload_from_mobile' && !this.capturedPhotoFromModal) {
      this.AttachFiles = [];
      this._api.openSnackBar('Take Photo', 'Error');
      return false;
    } else if (this.fileItems.some(f => f.sizeError)) {
      this._api.openSnackBar('Remove or replace files that exceed the size limit before submitting.', 'Error');
      return false;
    }

    const docComments = this.docForm.get('comments').value;
    const apiData = new FormData();

    // Device uploads — append EACH file with the same field name.
    // still bind them as an array instead of overwriting.
    if (this.AttachFiles.length > 0 && radioSelect === 'upload_from_device') {
      this.AttachFiles.forEach((item: File) => {
        apiData.append('files', item, item.name); // no brackets — matches multer.array('files', ...)
      });
    }

    if (this.capturedPhotoFromModal && radioSelect === 'upload_from_mobile') {
      const photos: string[] = Array.isArray(this.capturedPhotoFromModal)
        ? this.capturedPhotoFromModal
        : [this.capturedPhotoFromModal];

      photos.forEach((photoDataUrl: string, index: number) => {
        const blob = this.convertDataURLToBlob(photoDataUrl);
        const fileName = `${this.docTitle}_${this.timestamp}_${index}.png`;
        const file = new File([blob], fileName, { type: blob.type });
        apiData.append('files', file, fileName); // no brackets here either
      });
    }

    apiData.append('instance_id', localStorage.getItem('instance_id'));
    apiData.append('email', localStorage.getItem('email'));
    apiData.append('doc_type', this.docTitle);
    apiData.append('doc_comment', docComments);
    apiData.append('is_pii', 'N');
    apiData.append('isNotApplicable', 'N');

    this.spinner.show();
    setTimeout(() => {
      this._api.functionPOST('web/uploadDocument', apiData).subscribe(
        (response) => {
          this.spinner.hide();
          if (response['success']) {
            this._api.openSnackBar(response['data'], 'Success');
            this.selectedFile = '';
            this.apiImage = '';
            this.docForm.reset();
            this.dialogRef.close(true);
          }
        },
        (err) => {
          this.spinner.hide();
          this._api.openSnackBar(err.error, 'Error');
        }
      );
    }, 1000);
  }

  uploadAppDoc_single() {

    this.formSubmitted = true;
    const radioSelect = this.docForm.get('appDoc').value;
     if(!radioSelect){
        this._api.openSnackBar('Please select an option.', 'Error');
        return false;
      } else if(radioSelect === 'upload_from_device' && this.AttachFiles.length === 0){
        this.capturedPhotoFromModal = '';
        this._api.openSnackBar('Select a file', 'Error');
        return false;

      }else if(radioSelect === 'upload_from_mobile' && !this.capturedPhotoFromModal){
        this.AttachFiles = [];
        this._api.openSnackBar('Take Photo', 'Error');
        return false;
      }

    const docComments = this.docForm.get('comments').value;
      const apiData = new FormData();
      if (this.AttachFiles.length > 0 && radioSelect === 'upload_from_device') {
          this.AttachFiles.map((item) => {
            apiData.append('files', item);
          });
        }

        if(this.capturedPhotoFromModal && radioSelect === 'upload_from_mobile'){
          const blob = this.convertDataURLToBlob(this.capturedPhotoFromModal);
          const fileName = `${this.docTitle}_${this.timestamp}.png`;
          const file = new File([blob], fileName, { type: blob.type });
          apiData.append('files', file);
        }

      apiData.append('instance_id', localStorage.getItem('instance_id'));
      apiData.append('email', localStorage.getItem('email'));
      apiData.append('doc_type', this.docTitle);
      apiData.append('doc_comment', docComments);
      apiData.append('is_pii', 'N');
      apiData.append('isNotApplicable', 'N');
      setTimeout(() => {
      this.spinner.show();
      this._api.functionPOST('web/uploadDocument' , apiData).subscribe((response) => {
        if(response['success']){
          this._api.openSnackBar(response['data'] , 'Success');
          this.selectedFile = '';
          this.apiImage = '';
          this.docForm.reset();
          this.dialogRef.close(true);
        }
      },
      err => {
        this._api.openSnackBar(err.error, 'Error');
      });
    }, 1000);
      this.spinner.hide();
    }

}
